import { useRef, useCallback } from "react"

const useMapRecenter = (fitOptions) => {
  const mapInstanceRef = useRef(null)
  const boundsRef = useRef(null)
  const fitOptionsRef = useRef(fitOptions)

  const handleRecenter = useCallback(() => {
    if (mapInstanceRef.current && boundsRef.current) {
      mapInstanceRef.current.fitBounds(boundsRef.current, fitOptionsRef.current)
    }
  }, [])

  return { mapInstanceRef, boundsRef, handleRecenter }
}

export default useMapRecenter
